export default () => {
    return sessionStorage.removeItem('csrf_token');
}
